<template>
  <div>
    <Grid
      :service="service"
      order_column="created_date_formatted"
      direction="desc"
      route_name="reporting_channel_handling"
      route_grid_path="screening/grid"
      :ref="'grid'"
    >
      <template #severity_level_str-column="{ row }">
        <SeverityLevelBadge
          :label="row.severity_level_str || '-'"
          :color="
            (row.severity_level && row.severity_level.color) || 'secondary'
          "
        />
      </template>
      <template v-slot:actions="actions">
        <div class="flex flex-row gap-2">
          <feather-icon
            v-permission="`reporting_channel_handling.screening.edit`"
            icon="EditIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Editar nível de severidade',
              delay: { show: 100, hide: 100 }
            }"
            @click="editScreening(actions.row.id)"
          />
          <feather-icon
            v-permission="`reporting_channel_handling.detail`"
            icon="EyeIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Detalhar registro',
              delay: { show: 100, hide: 100 }
            }"
            @click="detail(actions.row.id)"
          />

          <feather-icon
            v-permission="`reporting_channel_handling.delete`"
            icon="Trash2Icon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
            v-tooltip.top="{
              content: 'Excluir registro',
              delay: { show: 100, hide: 100 }
            }"
            @click="destroy(actions.row.id)"
          />
        </div>
      </template>
    </Grid>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import SeverityLevelBadge from '@/components/SeverityLevelBadge.vue'

import ReportingChannelFormHandlingService from '@/services/api/reporting-channel/ReportingChannelFormHandlingService'

export default {
  directives: {},
  components: {
    BButton,
    SeverityLevelBadge
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    grid() {
      return this.$refs['grid']
    },
    editScreening(id) {
      this.$router.push(`/reporting-channel/${id}/screening`)
    },
    detail(id) {
      this.$router.push(`/reporting-channel/${id}`)
    },
    destroyModel(id) {
      this.$vs.loading()
      this.service
        .destroy(id)
        .then(
          response => {
            this.notifySuccess(this.$vs, 'Registro excluído com sucesso!')
            this.grid().fetchGridData()
          },
          error => {
            this.notifyError(
              this.$vs,
              'Não foi possível excluir o registro especificado'
            )
          }
        )
        .finally(() => this.$vs.loading.close())
    },
    destroy(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.destroyModel(id)
        }
      })
    }
  },
  beforeMount() {
    this.service = ReportingChannelFormHandlingService.build(this.$vs)
  }
}
</script>
